"use client";

// ===========================================
// konakla - Akıllı Geri Butonu
// router.back() kullanır; tarayıcı geçmişi yoksa fallback URL'e yönlendirir.
// ===========================================

import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface BackButtonProps {
  /** Geçmiş yoksa veya direkt link ile gelinmişse bu URL'e gider */
  fallbackHref?: string;
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
}

export function BackButton({
  fallbackHref = "/",
  className,
  ariaLabel = "Geri",
  children,
}: BackButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    // Tarayıcı geçmişi varsa (kullanıcı başka bir sayfadan buraya geldi) geri git.
    // Yoksa (direkt link, yeni sekme vb.) fallback'e yönlendir.
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push(fallbackHref);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={ariaLabel}
      className={cn("p-1", className)}
    >
      {children}
    </button>
  );
}
